import { TabCellContainer } from './CSS'
export default function TabCell({ text, isActive, handleClick }: any) {
  return (
    <TabCellContainer onClick={handleClick} isActive={isActive}>
      {text}
    </TabCellContainer>
  )
}
